module.exports = __webpack_public_path__ + "img/appointment_not_found.d50af551.png";